import DefaultLayout from "./DefaultLayout";
import MapLayout from "./MapLayout";


export default class Layouts{
    static Default = DefaultLayout;
    static Maps = MapLayout;
}